import script from "./UserItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserItem.vue?vue&type=script&setup=true&lang=ts"

import "./UserItem.vue?vue&type=style&index=0&id=7b7bc217&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b7bc217"]])

export default __exports__